import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/components/layouts/snippet-layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p className="t-lead">LearnUXD brings you this course on current trends in user experience design and tackle some additional project work to experiment in new and emerging areas.</p>
    <p>{`By the end of this course students will be able to:`}</p>
    <ul>
      <li parentName="ul">{`Recall and explain current trends in interactive design and related fields and apply them to real-world projects.`}</li>
      <li parentName="ul">{`Develop a value for stewardship of their time and talents and of lifelong learning.`}</li>
      <li parentName="ul">{`Research additional knowledge and skills on their own to reach fluency with terms and skills.`}</li>
      <li parentName="ul">{`Create an experimental interactive project.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      